$(document).on("click", ".remove_item", function (event) {
    const id = $(this).data('id')
    fetch('/cart/change.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ quantity: 0, id: id })
    }).then((response) => {
        refreshCartDrawer();
    });
})

async function refreshCartDrawer() {
    const CartData = await fetch('/cart.js')
        .then(response => response.json())
        .then(data => {
            document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
        });
}